export default __webpack_public_path__ + "static/media/student-unmuted.27d07590.svg";